import { useQuery } from 'react-query'
import client from './api-client'

const queryConfig = {
    staleTime: 1000 * 60 * 60,
    cacheTime: 1000 * 60 * 60,
}

// api/advanced_data/ifapa_stats/?parcel_id=600&from=2021-10-15&to=2021-10-20

async function fetchIfapaStats(parcel_id, from_date, to_date) {
    const dataIntegral = await client(`advanced_data/ifapa_stats/?parcel_id=${parcel_id}&from=${from_date}&to=${to_date}`)
    return dataIntegral
}

async function postIfapaStats(data) {
    const requestOptions = {
        body: data,
    };

    const dataIntegral = await client(`advanced_data/ifapa_stats/`, requestOptions)
    return dataIntegral
}


export function useIfapaStats(parcel_id, from_date, to_date) {
    return useQuery(['ifapa_stats', parcel_id, from_date, to_date], () => fetchIfapaStats(parcel_id, from_date, to_date), {
        enabled: false,
        refetchAllOnWindowFocus: false,
        ...queryConfig
    });
}


export function usePostIfapaStats(data) {
    return useQuery(['ifapa_stats', data.parcel_id, data.from_date, data.to_date], () => postIfapaStats(data), {
        enabled: false,
        refetchAllOnWindowFocus: false,
        ...queryConfig
    });
}